<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    {{$t('news.template.opinion.changedByOrgSplit.p1')}}
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.opinion.changedByOrgSplit.p2')}}
    <router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[2]}}"
    >{{ news.textParams[3] }}
    </router-link>
    {{$t('news.template.opinion.changedByOrgSplit.p3')}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[4]}}">
      {{news.textParams[5]}}
    </router-link>.
    {{$t('news.template.opinion.changedByOrgSplit.p4')}}
    {{ news.textParams[6] }}
    {{$t('news.template.opinion.changedByOrgSplit.p5')}}
  </div>
</template>
